var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSection2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.07175 20.2033C3.44208 20.2033 2.9055 19.9815 2.462 19.538C2.0185 19.0945 1.79675 18.5579 1.79675 17.9283V6.07175C1.79675 5.44209 2.0185 4.9055 2.462 4.462C2.9055 4.0185 3.44208 3.79675 4.07175 3.79675H19.9283C20.5579 3.79675 21.0945 4.0185 21.538 4.462C21.9815 4.9055 22.2033 5.44209 22.2033 6.07175V17.9283C22.2033 18.5579 21.9815 19.0945 21.538 19.538C21.0945 19.9815 20.5579 20.2033 19.9283 20.2033H4.07175ZM4.07175 17.9283H10.9V6.07175H4.07175V17.9283ZM13.2 17.9283H19.9283V6.07175H13.2V17.9283Z",
    fill: "#092B4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection2);
export default __webpack_public_path__ + "static/media/section2.b7770def56f3b62eb65dc80796326109.svg";
export { ForwardRef as ReactComponent };